export class RegexPatterns {
    static readonly CLIENT_NUMBER_VALIDATION_PATTERN: RegExp = /^\d{3}-\d{3}-\d{2}$/;
    static readonly CLIENT_NUMBER_VALIDATION_ARRAY: any = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    static readonly FIRST_NAME_VALIDATION_PATTERN: RegExp = /^[a-zA-Z\s\.'\-]*$/;
    static readonly LAST_NAME_VALIDATION_PATTERN: RegExp = /^[a-zA-Z\s\.'\-]*$/;
    static readonly LAST_FOUR_DIGITS_VALIDATION_PATTERN: RegExp = /^[0-9]{4}$/;

    static readonly EMAIL_VALIDATION_PATTERN: RegExp = /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,4})+)$/;
    static readonly USERNAME_VALIDATION_PATTERN: RegExp = /(^[a-zA-Z][a-zA-Z0-9\.\-]{7,15}$)/;
    static readonly PASSWORD_VALIDATION_PATTERN: RegExp = /(^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*\-])[a-zA-Z\d!@#$%^&*\-]{7,15}[a-zA-Z\d!@$%^&*]$)/;

    static readonly SECURITY_QUESTION_ANSWER_PATTERN: RegExp = /([a-zA-Z0-9\.\-\s\']{4}$)/;

    static readonly PHONE_NUMBER_VALIDATION_PATTERN: RegExp = /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/;
    static readonly PHONE_NUMBER_VALIDATION_ARRAY: any = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    static readonly PHONE_COUNTRY_CODE_VALIDATON_PATTERN: RegExp = /^[0-9]{1,3}$/;
    static readonly PHONE_EXTENSION_VALIDATION_PATTERN: RegExp = /^[0-9]{0,4}$/;
}